import { Lock } from 'lucide-react';
import { c, t, sp, r } from '../../theme';

// Dashed rather than solid, so an empty slot never reads as a card that failed
// to load — it reads as one deliberately left open.

// A panel the target design calls for that the data cannot fill yet.
//
// It renders the slot with the reason in it rather than omitting the panel or
// filling it with a placeholder chart. Omitting reads as "nobody thought of
// it"; a placeholder reads as real and gets quoted in a meeting. Naming the
// missing input puts the question where it can actually be answered — usually
// with the source system, not with us.
export default function PendingPanel({ title, needs, detail }) {
  return (
    <div style={s.panel}>
      <div style={s.head}>
        <div style={s.title}>{title}</div>
        <span style={s.chip}><Lock size={11} /> Not available yet</span>
      </div>
      <div style={s.body}>
        <div style={s.needs}>Needs {needs}</div>
        {detail && <div style={s.detail}>{detail}</div>}
      </div>
    </div>
  );
}

const s = {
  panel: {
    background: c.surfaceSunk,
    border: `1px dashed ${c.borderStrong}`,
    borderRadius: r.xl,
    display: 'flex', flexDirection: 'column',
  },
  head: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    gap: sp[3], padding: `${sp[3]} ${sp[4]}`, borderBottom: `1px dashed ${c.border}`,
  },
  title: { ...t.h3, color: c.textMuted },
  chip: {
    ...t.micro, color: c.textFaint, display: 'inline-flex', alignItems: 'center', gap: '4px',
    border: `1px solid ${c.border}`, borderRadius: r.pill, padding: '2px 8px', whiteSpace: 'nowrap',
  },
  body:   { padding: sp[4], display: 'flex', flexDirection: 'column', gap: sp[2] },
  needs:  { ...t.bodySm, color: c.textStrong, fontWeight: 600 },
  detail: { ...t.caption, color: c.textMuted, lineHeight: 1.55 },
};
